import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PAGE_NAME, UserModelData } from "../types";
import AppLayout from "./AppLayout";
import arthereumProvider from "../backend/ArthereumProvider";
import { actions } from "../WebAppsSharedStuffs/redux";
import getUserSignInData from "../WebAppsSharedStuffs/utils/getUserSignInData";
import {
  LocalStorageController,
  LOCAL_STORAGE_DATA,
} from "../WebAppsSharedStuffs/utils/LocalStorageController";
import LoadingIndicator from "../WebAppsSharedStuffs/components/LoadingIndicator";

import { isAllowedDomain, UnsupportedDomainCard } from "../WebAppsSharedStuffs/components/DomainGuard";

interface AuthRouteProps {
  children: React.ReactNode;
}

const AuthRoute: React.FC<AuthRouteProps> = ({ children }) => {
  const userData: UserModelData = useSelector(
    (state) => (state as any)?.actualUser
  );
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(userData?.user?.id ? false : true);
  const navigate = useNavigate();
  const [unKnowError, setUnKnowError] = useState(false);
  const [isWrongDomain, setIsWrongDomain] = useState(false);
  const init = async () => {
    try {
      // Check domain first, before any async operations
      if (!isAllowedDomain()) {
        setIsWrongDomain(true);
        return;
      }

      setUnKnowError(false);
      setLoading(true);

      const SYSTEM_FULLY_INITIALIZED = LocalStorageController.connect().getData(
        LOCAL_STORAGE_DATA.SYSTEM_FULLY_INITIALIZED,
        "string"
      );

      if (SYSTEM_FULLY_INITIALIZED === "false" || !SYSTEM_FULLY_INITIALIZED) {
        navigate(PAGE_NAME.LOGIN, { replace: true });
        return;
      }
      const userCredentials = await getUserSignInData();
      console.log("User credentials", userCredentials);

      // sign in
      const user = await arthereumProvider.signIn(userCredentials);
      dispatch(actions.setActualUser(user));
      LocalStorageController.connect().storeData(
        LOCAL_STORAGE_DATA.SIGN_IN_PATH,
        user?.user?.signUpMethod
      );
      //save user in redux
      navigate(PAGE_NAME.HOME, { replace: true });
    } catch (error: any) {
      if (error?.message === "Invalid credentials") {
        navigate(PAGE_NAME.LOGIN, { replace: true });
      } else {
        setUnKnowError(true);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isLoading) {
      init();
    }
  }, []);

  if (isWrongDomain) {
    return <UnsupportedDomainCard />;
  }

  return isLoading ? (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <LoadingIndicator />
    </div>
  ) : (
    <AppLayout>{children}</AppLayout>
  ); // Wrap children with AppLayout
};

export default AuthRoute;
